module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-lock-fill-e8c920a6.svg";